import { ContentBlock } from './content-block';

export type ApiContentBlock = { [key: string]: any; };
export function contentBlocksFromApi(blocks: ApiContentBlock[]): ContentBlock[] {
    return <ContentBlock[]>blocks;
}

export const CONTENT_TYPE_HELPER = {
    contentBlocksFromApi
};